import { BaseFeature, FeatureType } from '@core/shared/feature';
export class AbilitiesBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/abilities/feature","featureId":"common-abilities"},
      bundledItemModels: ["SkillsetItem", "SkillsetMappingItem"],
      // list is auto-generated by generate-model-ids
      abilityActions: false,
      plugins: [
      // {forPlatform:'frontend', type:FeatureType.Permanent, pluginClassName:'AbilitiesFrontendFeature'},
      // {forPlatform:'frontend-management', type:FeatureType.Dynamic, pluginClassName:'AbilitiesFrontendManagementFeature', simpleAbilityCheck:'MANAGER' },
      {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'AbilitiesFrontendAdminFeature'
      }, {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'AbilitiesBackendFeature'
      }, {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'AbilitiesBackendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {}
      }
    };
  }
}